import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { IdentityValues, BankingValues, ServicesValues } from '@/lib/validators/onboarding';

export type OnboardingStep = 'identity' | 'banking' | 'services' | 'voice';

interface OnboardingState {
  currentStep: OnboardingStep;
  identity: Partial<IdentityValues>;
  banking: Partial<BankingValues>;
  services: Partial<ServicesValues>;
  gdprConsentVersion: string;
  gdprConsentAt: string | null;

  setStep: (step: OnboardingStep) => void;
  setIdentity: (data: Partial<IdentityValues>) => void;
  setBanking: (data: Partial<BankingValues>) => void;
  setServices: (data: Partial<ServicesValues>) => void;
  recordGdprConsent: () => void;
  reset: () => void;
}

const INITIAL_STATE = {
  currentStep: 'identity' as OnboardingStep,
  identity: {},
  banking: { paymentTermsDays: 30, lateInterestPct: 8 },
  services: {},
  gdprConsentVersion: '2026-06-v1',
  gdprConsentAt: null,
};

export const useOnboardingStore = create<OnboardingState>()(
  persist(
    (set) => ({
      ...INITIAL_STATE,

      setStep: (step) => set({ currentStep: step }),

      setIdentity: (data) =>
        set((s) => ({ identity: { ...s.identity, ...data } })),

      setBanking: (data) =>
        set((s) => ({ banking: { ...s.banking, ...data } })),

      setServices: (data) =>
        set((s) => ({ services: { ...s.services, ...data } })),

      recordGdprConsent: () =>
        set({ gdprConsentAt: new Date().toISOString() }),

      reset: () => set(INITIAL_STATE),
    }),
    {
      name: 'tc-onboarding',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
